import { render } from "./Sidebar.vue?vue&type=template&id=6a4f912b&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=6a4f912b&lang=scss&scoped=true"

import exportComponent from "/home/phamdat/project/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4f912b"]])

export default __exports__